import { esOrangePalettes } from "../../../../Posts/01-paletas/05-paleta-naranja/orangePalettes.js";
import * as React from 'react';
export default {
  esOrangePalettes,
  React
};